import { createRouter, createWebHistory } from 'vue-router';
import { i18n } from '@/i18n'
import { computed } from 'vue';
import { checkOffline, loadPageView, getBase } from '@/utility/index';
import middleware from './middleware';
import list from './list'
import chats from './chat'
import stories from './story'
import settings from './setting';
import wallet from './wallet';
import portfolio from './portfolio';
import pages from './pages';
import ads from './ads'
import membership from './membership'
import groups from './groups'
import vibb from './vibb'
import { useAppStore } from '../store/app';
import { trackProfileVisit } from '@/utility/ref-tracking';

const routes = [
  {
    path: '/network',
    name: 'network',
    component: loadPageView('network'),
    beforeEnter: middleware.user,
    meta: { title: computed(() => i18n.global.t('Network')) }
  },
  {
    path: '/articles',
    name: 'articles_browse',
    component: () => import('@/pages/articles/browse/index.vue'),
    beforeEnter: middleware.all,
    meta: { title: computed(() => i18n.global.t('Latest Articles')) }
  },
  {
    path: '/'+ window.siteConfig.profilePrefix +':user_name/articles',
    name: 'user_articles',
    component: () => import('@/pages/articles/user/index.vue'),
    beforeEnter: middleware.all,
    meta: { title: computed(() => i18n.global.t('Articles')) }
  },
  {
    path: '/article/:slug',
    name: 'article_show',
    component: () => import('@/pages/articles/show/index.vue'),
    beforeEnter: middleware.all,
    meta: { title: computed(() => i18n.global.t('Article')) }
  },
  {
    path: '/articles/editor',
    name: 'article_editor',
    component: () => import('@/pages/articles/editor/index.vue'),
    beforeEnter: middleware.user,
    meta: { title: computed(() => i18n.global.t('New Article')) }
  },
  {
    path: '/calculatoare/page/:page(\\d+)',
    name: 'calculator_index_page',
    component: () => import('@/pages/calculators/Index.vue'),
    beforeEnter: middleware.all
  },
  {
    path: '/calculatoare/:slug',
    name: 'calculator_show',
    component: () => import('@/pages/calculators/CalculatorPage.vue'),
    beforeEnter: middleware.all
  },
  {
    path: '/calculatoare',
    name: 'calculator_index',
    component: () => import('@/pages/calculators/Index.vue'),
    beforeEnter: middleware.all
  },
  {
    path: '/stocks',
    name: 'stocks',
    component: () => import('@/pages/stocks/index.vue'),
    beforeEnter: middleware.all,
    meta: { title: computed(() => i18n.global.t('Stocks')) }
  },
  {
    path: '',
    name: 'home',
    component: () => import('@/pages/ServerLayout.vue'),
    meta: { title: computed(() => i18n.global.t('Home')) }
  },
  {
    path: '/page/:page(\\d+)',
    name: 'home_page',
    component: () => import('@/pages/ServerLayout.vue'),
    meta: { title: computed(() => i18n.global.t('Home')) }
  },
  {
    path: '/'+ window.siteConfig.profilePrefix +':user_name?/:tab?',
    name: 'profile',
    component: () => import('@/pages/ServerLayout.vue'),
    beforeEnter: middleware.all,
    meta: { title: computed(() => i18n.global.t('Profile')) }
  },
  {
    path: '/first-login',
    name: 'first_login',
    component: loadPageView('first_login'),
    beforeEnter: middleware.user,
    meta: { title: computed(() => i18n.global.t('Hashtags Signup')) }
  },
  {
    path: '/invites/:tab?',
    name: 'invites',
    props: true,
    component: loadPageView('invites'),
    beforeEnter: middleware.user,
    meta: { title: computed(() => i18n.global.t('Invites')) }
  },
  {
    path: '/post/:slug/:comment_id?/:reply_id?',
    name: 'post',
    component: () => import('@/pages/ServerLayout.vue'),
    beforeEnter: middleware.all,
    meta: { title: computed(() => i18n.global.t('Post Detail')) }
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: loadPageView('notifications'),
    beforeEnter: middleware.user,
    meta: { title: computed(() => i18n.global.t('Notifications')) }
  },
  {
    path: '/search/:search_type/:type',
    name: 'search',
    props: true,
    beforeEnter: middleware.all,
    component: loadPageView('search'),
    meta: { title: computed(() => i18n.global.t('Search')) }
  },
  {
    path: '/search/text/:type/:term',
    name: 'search_text',
    props: route => ({ search_type: 'text', type: route.params.type, term: route.params.term }),
    beforeEnter: middleware.all,
    component: loadPageView('search'),
    meta: { title: computed(() => i18n.global.t('Search')) }
  },
  {
    path: '/discovery',
    name: 'discovery',
    component: () => import('@/pages/ServerLayout.vue'),
    beforeEnter: middleware.all,
    meta: { title: computed(() => i18n.global.t('Discovery')) }
  },
  {
    path: '/watch',
    name: 'watch',
    component: () => import('@/pages/ServerLayout.vue'),
    beforeEnter: middleware.all,
    meta: { title: computed(() => i18n.global.t('Watch')) }
  },
  {
    path: '/register',
    name: 'register',
    component: loadPageView('register'),
    beforeEnter: middleware.guest,
    meta: { title: computed(() => i18n.global.t('Register')) }
  },
  {
    path: '/login',
    name: 'login',
    component: loadPageView('login'),
    beforeEnter: middleware.guest,
    meta: { title: computed(() => i18n.global.t('Login')) }
  },
  {
    path: '/signup',
    name: 'signup',
    component: loadPageView('signup'),
    beforeEnter: middleware.guest,
    meta: { title: computed(() => i18n.global.t('Signup')) }
  },
  {
    path: '/social-consent',
    name: 'social_consent',
    component: loadPageView('social_consent'),
    beforeEnter: middleware.guest,
    meta: { title: computed(() => i18n.global.t('Social Login')) }
  },
  {
    path: '/openid/auth/:name',
    name: 'openid',
    component: loadPageView('openid'),
    meta: { title: computed(() => i18n.global.t('Social Login')) }
  },
  {
    path: '/game',
    name: 'game',
    component: loadPageView('game'),
    beforeEnter: middleware.all,
    meta: { title: computed(() => i18n.global.t('Game')) }
  },
  {
    path: '/:catchAll(.*)',
    name: 'page_not_found',
    component: loadPageView('page_not_found'),
    meta: { title: computed(() => i18n.global.t('Page Not Found')) }
  },
  {
    path: '/bookmarks',
    name: 'bookmarks',
    component: () => import('@/pages/ServerLayout.vue'),
    beforeEnter: middleware.user,
    meta: { title: computed(() => i18n.global.t('Bookmark')) }
  },
  {
    path: '/hashtags/:tab?',
    name: 'hashtags',
    props: true,
    component: loadPageView('hashtags'),
    beforeEnter: middleware.user,
    meta: { title: computed(() => i18n.global.t('Hashtags')) }
  },
  {
    path: '/users/:tab?',
    name: 'users',
    props: true,
    component: loadPageView('users'),
    beforeEnter: middleware.user,
    meta: { title: computed(() => i18n.global.t('UsersPage')) }
  },
  {
    path: '/unsubscribe/:email/:hash',
    name: 'unsubscribe',
    props: true,
    component: loadPageView('unsubscribe'),
    meta: { title: computed(() => i18n.global.t('Unsubscribe')) }
  },
  {
    path: '/email_confirm',
    name: 'email_confirm',
    props: true,
    component: loadPageView('email_confirm'),
    beforeEnter: middleware.user,
    meta: { title: computed(() => i18n.global.t('Email Confirm')) }
  },
  {
    path: '/sp/:slug',
    name: 'sp_detail',
    component: () => import('@/pages/ServerLayout.vue'),
    meta: { title: computed(() => i18n.global.t('Page')) }
  },
  {
    path: '/contact',
    name: 'contact',
    component: loadPageView('contact'),
    meta: { title: computed(() => i18n.global.t('Contact Us')) }
  },
  {
    path: '/recover',
    name: 'recover',
    component: loadPageView('recover'),
    beforeEnter: middleware.guest,
    meta: { title: computed(() => i18n.global.t('Recover')) }
  },
  {
    path: '/permission',
    name: 'permission',
    component: loadPageView('permission'),
    beforeEnter: middleware.user,
    meta: { title: computed(() => i18n.global.t('Permission')) }
  },
  {
    path: '/verify_profile',
    name: 'verify_profile',
    component: loadPageView('verify_profile'),
    beforeEnter: middleware.user,
    meta: { title: computed(() => i18n.global.t('Verify Profile')) }
  },
  {
    path: '/media',
    name: 'media',
    component: () => import('@/pages/ServerLayout.vue'),
    beforeEnter: middleware.all,
    meta: { title: computed(() => i18n.global.t('Media')) }
  },
  {
    path: '/documents',
    name: 'documents',
    component: () => import('@/pages/ServerLayout.vue'),
    beforeEnter: middleware.all,
    meta: { title: computed(() => i18n.global.t('Documents')) }
  },
  {
    path: '/phone_confirm',
    name: 'phone_confirm',
    component: loadPageView('phone_confirm'),
    beforeEnter: middleware.user,
    meta: { title: computed(() => i18n.global.t('Phone Confirm')) }
  },
  {
    path: '/two_factor_authentication',
    name: 'two_factor_authentication',
    component: loadPageView('two_factor'),
    beforeEnter: middleware.guest,
    meta: { title: computed(() => i18n.global.t('Two-factor authentication')) }
  },
  {
    path: '/chatbot',
    name: 'chatbot',
    component: loadPageView('chatbot'),
    beforeEnter: middleware.user,
    meta: { title: computed(() => i18n.global.t('Chatbot')) }
  },
];

routes.push(
  ...list,
  ...settings,
  ...chats,
  ...stories,
  ...wallet,
  ...portfolio,
  ...pages,
  ...ads,
  ...membership,
  ...groups,
  ...vibb
);

const router = createRouter({
  history: createWebHistory(getBase()),
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
  routes,
});

router.afterEach((to, from) => {
  useAppStore().setErrorLayout(false)
  if (from.fullPath == to.fullPath) {
    return
  }
  if (window.gtag && window.gaMeasurementId) {
    window.gtag('config', window.gaMeasurementId, {
      page_path: to.fullPath,
      page_title: document.title,
      page_location: window.location.href
    })
  }
  if (to.name === 'profile' && to.params && to.params.user_name) {
    trackProfileVisit(to.params.user_name)
  }
}); 

router.beforeEach(async (to) => {
  if (to.name !== 'home' && checkOffline()) {
    // redirect the user to the login page
    return { name: 'home' }
  }

  document.querySelectorAll(".p-dialog-mask").forEach(el => el.remove());
  document.body.classList.remove('p-overflow-hidden', 'overflow-hidden');
  useAppStore().setIsOpenSidebar(false)
})

export default router;
